import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  CreditLockFileInfo,
  CreditLockSliceType,
  LockStatus,
} from './types';

const initialState: CreditLockSliceType = {
  fileInfo: null,
};

const creditLockSlice = createAppSlice({
  name: 'creditLock',
  initialState,
  reducers: {
    setCreditLockFileInfo(
      state,
      action: PayloadAction<CreditLockFileInfo[] | null>,
    ) {
      state.fileInfo = action.payload;
    },
    setVendorLockStatus(
      state,
      action: PayloadAction<{ vendorCode: string; lockStatus: LockStatus }>,
    ) {
      if (!state.fileInfo) return;
      state.fileInfo = state.fileInfo.map((file) =>
        file.vendorCode === action.payload.vendorCode
          ? { ...file, lockStatus: action.payload.lockStatus }
          : file,
      );
    },
  },
});

export const { setCreditLockFileInfo, setVendorLockStatus } =
  creditLockSlice.actions;

export default creditLockSlice.reducer;
